
export class DownloadUserPassRequestDto {
  ticketOrderId: string;
}
